module.exports = __webpack_public_path__ + "img/lift-entrance-opened.4261227b.jpg";